module.exports = __webpack_public_path__ + "media/images/contest_voter_campaigns/kv-8ef565d3521e8693cab3bb118a4a56e7.png";